import { createFileRoute } from '@tanstack/react-router'
import { Settings } from 'lucide-react'
import { SettingsScreen } from '@/screens/workspace/SCR-054-settings'

export const Route = createFileRoute('/_app/w/$ws/settings')({
  staticData: { screen: {"id":"SCR-054","title":"Workspace settings","group":"Workspace","perm":"workspace.admin","order":13,"description":"Name, members, retention, review and assembly settings for this workspace.", icon: Settings } },
  component: SettingsScreen,
})
